import { render, staticRenderFns } from "./SenderOrderMailTag.vue?vue&type=template&id=6bd21336"
import script from "./SenderOrderMailTag.vue?vue&type=script&lang=js"
export * from "./SenderOrderMailTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports